module.exports = __webpack_public_path__ + "static/media/evening.d3dd976d.png";